import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap"; 

import * as apiUrl from "../../apiUrl";

function MilestoneDescription() {
  const [MilestoneDescription, setMilestoneDescription] = useState({});

  useEffect(() => {
    const fetchMilestoneDescription = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/milestones/second-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setMilestoneDescription(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchMilestoneDescription();
  }, []);

  return ( 
      <section className="about-amenities-sec awards-list-sec">
        <Container fluid>
          <Row className="flex-center">
            <Col md={8} className="padding-zero">
              <div className="text-center mb-5" data-aos="fade-up">
                <h2 className="common-head greyColor">
                  {MilestoneDescription.section_title}
                </h2>
                <p className="common-para">
                  {MilestoneDescription.section_description}​
                </p>
              </div>
            </Col>
          </Row>
        </Container>
        <Container fluid>
          <Row className="flex-center">
            <Col md={10} className="padding-zero">
              <div className="about-amenity-img" data-aos="fade-up">
                <img
                  src={`${apiUrl.apiUrl}/${MilestoneDescription.section_image}`}
                  className="img-fluid"
                  alt="Amenity"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section> 
  );
}
export default MilestoneDescription;
